import { render } from "./BiancaEluisa.vue?vue&type=template&id=4fcf2392"
import script from "./BiancaEluisa.vue?vue&type=script&lang=js"
export * from "./BiancaEluisa.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__